interface RadioProps {
  options: Array<{
    id: string;
    label: string;
    icon?: React.ReactNode;
    variant?: "input" | "primary";
    state: "selected" | "notSelected";
  }>;
  containerClassName?: string;
  textClassName?: string;
  onSelect: (id: string) => void;
}

export const Radio: React.FC<RadioProps> = ({ options, onSelect, textClassName, containerClassName }) => {
  const getVariantStyles = (variant: string, state: string) => {

    switch (variant) {
      case "input":
        return state === "selected"
          ? "bg-white text-black border-2 border-osBlack rounded-[1.375rem]"
          : "bg-white text-black border-2 border-osGrey-4 rounded-[1.375rem]";
      case "primary":
        return state === "selected"
          ? "bg-black text-white border-4 border-osBlack rounded-[1.375rem] p-4 w-full"
          : "bg-black text-white border-2 border-black rounded-[1.375rem] p-4 w-full hover:border-grey-3";
      default:
        return "";
    }
  };

  return (
    <div className={`space-y-2 w-full ${containerClassName}`}>
      {options.map((option) => (
        <div
          key={option.id}
          className={`p-4 cursor-pointer transition-all ease-in-out relative ${getVariantStyles(option.variant || "input", option.state)}`}
          onClick={() => onSelect(option.id)}
        >
          <div className="flex items-center justify-center">
            {option.icon && <span className="mr-2">{option.icon}</span>}
            <span className={`text-center ${textClassName}`}>
              {option.label}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
